const SVG_MIME_TYPES = new Set(['image/svg+xml', 'image/svg']);

export function isSvgUploadFile(file: {
  type?: string;
  name?: string;
}): boolean {
  const type = (file?.type || '').toLowerCase();
  if (SVG_MIME_TYPES.has(type)) {
    return true;
  }

  return (file?.name || '').toLowerCase().endsWith('.svg');
}

export function shouldValidateUploadDimensions(file: {
  type?: string;
  name?: string;
}): boolean {
  return !isSvgUploadFile(file);
}

export function shouldCompressUpload(
  file: { type?: string; name?: string },
  compressRequested: boolean
): boolean {
  return compressRequested && !isSvgUploadFile(file);
}

export function isImageProportionWithinPercentMargin(
  width: number,
  height: number,
  expectedWidth: number,
  expectedHeight: number,
  marginPercent: number
): boolean {
  if (
    width <= 0 ||
    height <= 0 ||
    expectedWidth <= 0 ||
    expectedHeight <= 0 ||
    marginPercent < 0
  ) {
    return false;
  }

  const marginFactor = marginPercent / 100;
  const isWidthWithinExpected =
    Math.abs(width - expectedWidth) <= expectedWidth * marginFactor;
  const isHeightWithinExpected =
    Math.abs(height - expectedHeight) <= expectedHeight * marginFactor;

  if (isWidthWithinExpected && isHeightWithinExpected) {
    return true;
  }

  const expectedHeightForWidth = (width * expectedHeight) / expectedWidth;
  const expectedWidthForHeight = (height * expectedWidth) / expectedHeight;

  return (
    Math.abs(height - expectedHeightForWidth) <=
      expectedHeightForWidth * marginFactor &&
    Math.abs(width - expectedWidthForHeight) <=
      expectedWidthForHeight * marginFactor
  );
}

export function loadImageNaturalSize(
  src: string
): Promise<{ width: number; height: number }> {
  return new Promise((resolve, reject) => {
    if (!src) {
      reject(new Error('empty-image-src'));
      return;
    }

    const img = new Image();
    img.onload = () => {
      resolve({ width: img.naturalWidth, height: img.naturalHeight });
    };
    img.onerror = () => {
      reject(new Error('image-load-failed'));
    };
    img.src = src;
  });
}
